import { atom } from "recoil"

const conditionSpecificAtom = atom({
    key: 'conditionSpecific',
    default: {}
})

export default conditionSpecificAtom